<template>
  <div class="custom-notification" ref="notif">
    <notification-bell
      v-if="UnreadMessagesCount"
      :count="UnreadMessagesCount"
      counterLocation="lowerLeft"
      iconColor="white"
      counterBackgroundColor="red"
      counterTextColor="white"
      counterStyle="round"
      :size="25"
      :upperLimit="500"
      fontSize="14px"
    />
  </div>
</template>

<script>
import NotificationBell from "vue-notification-bell";
export default {
  components: {
    notificationBell: NotificationBell,
  },
  computed: {
    UnreadMessagesCount() {
      return this.$store.getters.UnreadMessagesCount;
    },
  },
  methods: {
    goToMessages() {
      this.$router.push("/messages");
    },
  },
  // mounted() {
  //   document.getElementById(
  //     "notificationBell"
  //   ).childNodes[0].childNodes[0].childNodes[0].innerHTML = "";
  // },
};
</script>
<style>
.custom-notification {
  position: relative;
  bottom: -9.25px;
  z-index: 3;

  left: 13.25px;
}
.notification-counter {
  width: 25px !important;
  height: 25px !important;
  padding: 2px 2px !important;
}
#notificationBell .notification {
  width: unset !important;
}

#notificationBell .notification svg {
  display: none;
}
</style>
